var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStepActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Component 28"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 24022",
    d: "M20.1429 12C20.1429 16.4972 16.4972 20.1429 12 20.1429C7.50282 20.1429 3.85714 16.4972 3.85714 12C3.85714 7.50282 7.50282 3.85714 12 3.85714C16.4972 3.85714 20.1429 7.50282 20.1429 12Z",
    strokeWidth: 7.71429,
    stroke: "#0D44AD"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStepActive);
export default __webpack_public_path__ + "static/media/step-active.7e192f1abfd2f13be6fc97d35c5813d9.svg";
export { ForwardRef as ReactComponent };